var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVolume = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 14",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M 8.717 0.05 C 8.543 -0.033 8.338 -0.011 8.188 0.11 L 3.324 4.001 L 1 4.001 C 0.449 4.001 0 4.45 0 5.001 L 0 9.001 C 0 9.553 0.449 10.001 1 10.001 L 3.324 10.001 L 8.187 13.892 C 8.278 13.964 8.389 14.001 8.5 14.001 C 8.574 14.001 8.648 13.984 8.717 13.951 C 8.89 13.868 9 13.693 9 13.501 L 9 0.501 C 9 0.309 8.89 0.134 8.717 0.05 Z",
  fill: "currentColor"
})));
export default SvgVolume;